import React, { Component } from 'react';
import { observer } from 'mobx-react';

import {BellOutlined } from '@ant-design/icons';

class MessageButton extends Component {

    constructor(props) {
        super(props);
    }

  
    showPendingFeeds = () => {
    }

    renderButton = () => {
        return <BellOutlined  />
    }

    render() {

        return (
            <>
                {this.renderButton()}
            </>
        )
    }
}

export default observer(MessageButton);